import axios from 'axios';
import { getActiveOrgUuid, getToken } from '../utils/LocalStorageHelper';
import { getCommonElements, IModuleId } from '../utils/SubsystemUtils';

export const registrationApiUrl = process.env.REACT_APP_API_REGISTRATION_URL || '';
export const idmApiUrl = process.env.REACT_APP_API_IDM_URL || '';

const getOrgSubsystems = () =>
  axios
    .get(`${idmApiUrl}/me`, {
      params: { organizationUuid: getActiveOrgUuid() },
      headers: { Authorization: `Bearer ${getToken()}` },
    })
    .then(({ data }) => data.subsystems as IModuleId[]);

const getUserSubsystems = () =>
  axios
    .get(`${registrationApiUrl}/organization/${getActiveOrgUuid()}`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    })
    .then(({ data }) => data.activeSubsystems as IModuleId[]);

export const getUserOrgSubsystems = () =>
  Promise.all([getOrgSubsystems(), getUserSubsystems()]).then(
    ([orgSubsystems, userSubsystems]) => getCommonElements(orgSubsystems, userSubsystems)
  );
